import React from "react";
import Modal from "react-bootstrap/Modal";
import { useGetPageQuery } from "../../../redux/services/crmAPI";
import { useState, useEffect } from "react";
import { useGetPageUnloadQuery } from "../../../redux/services/noLoadingReqAPI";
import { useRef } from "react";
import AddPositionSelect from "../../addPositionSelect/AddPositionSelect";
import moment from "moment/moment";

const ModalFind = ({ showSearchModal, setShowSearchModalWindow }) => {
    const handleClose = () => setShowSearchModalWindow(false);

    const searchPositionRef = useRef();
    const inputPositionRef = useRef();

    const [productSearchInput, setProductSearchInput] = useState("");
    const [selectedProduct, setSelectedProduct] = useState("");
    const [showSearchPositionList, setShowSearchPositionList] = useState(false);

    const { data: orderPositions } = useGetPageUnloadQuery(
        "orders/positions?limit=15&quantity=2&search=" + productSearchInput
    );
    const { data: product, refetch: refetchProduct } = useGetPageQuery("products/" + selectedProduct.id, {
        skip: !selectedProduct,
    });

    const addPositionHandler = (position) => {
        setSelectedProduct(position);
        setProductSearchInput(position.title);
        setShowSearchPositionList(false);
    };

    useEffect(() => {
        const outsideHandleClick = (e) => {
            if (
                inputPositionRef.current &&
                !e.composedPath().includes(inputPositionRef.current) &&
                searchPositionRef.current &&
                !e.composedPath().includes(searchPositionRef.current)
            ) {
                setShowSearchPositionList(false);
            }
        };

        document.body.addEventListener("click", outsideHandleClick);

        return () => {
            document.body.removeEventListener("click", outsideHandleClick);
        };
    }, []);

    const jsonToStaringHandler = (arr) => {
        const str = Object.keys(arr)
            .map(function (key) {
                return "" + key + "=" + arr[key];
            })
            .join("/ ");
        return str;
    };

    return (
        <Modal
            show={showSearchModal}
            onHide={setShowSearchModalWindow}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Пошук товарів</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {orderPositions && (
                    <div className="form-group">
                        <label className="mb-2">Введіть IMEI або проскануйте штрихкод</label>
                        <input
                            type="text"
                            className="form-control"
                            value={productSearchInput}
                            onChange={(e) => setProductSearchInput(e.target.value)}
                            ref={inputPositionRef}
                            onFocus={() => setShowSearchPositionList(true)}
                            autocomplete="off"
                        />
                        <div ref={searchPositionRef}>
                            {showSearchPositionList && (
                                <AddPositionSelect
                                    orderPositions={orderPositions}
                                    addPositionHandler={addPositionHandler}
                                    positions={[]}
                                />
                            )}
                        </div>
                        {product && (
                            <div className="my-3">
                                <table className="table table-striped">
                                    <tbody>
                                        <tr>
                                            <td>Назва</td>
                                            <td className="res_name">{product?.title}</td>
                                        </tr>
                                        <tr>
                                            <td>Стан</td>
                                            <td className="res_product_status">{product?.status}</td>
                                        </tr>
                                        <tr>
                                            <td>Стан АКБ</td>
                                            <td className="res_battery">{product?.status_battery}</td>
                                        </tr>
                                        <tr>
                                            <td>IMEI/SN</td>
                                            <td className="res_imei">{product?.imei_sn}</td>
                                        </tr>
                                        <tr>
                                            <td>Статус</td>
                                            <td className="res_status">
                                                <span className="badge bg-success">
                                                    {product.quantity ? "Товар в наявності" : "Товар не в наявності"}
                                                </span>
                                                {+product.is_spare_parts === 1 && (
                                                    <span className="badge bg-danger ms-1">
                                                        Товар списаний на запчастини
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Ціна</td>
                                            <td className="res_price">{product.price}</td>
                                        </tr>
                                        <tr>
                                            <td>Склад</td>
                                            <td className="res_stock">{product.quantity}</td>
                                        </tr>
                                        <tr>
                                            <td>Магазин</td>
                                            <td className="res_store_name">{product?.store?.title}</td>
                                        </tr>
                                        <tr>
                                            <td>Створено</td>
                                            <td className="res_created">
                                                {moment(product.created_at).format("DD.MM.YYYY hh:MM")}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div className="res_logs">
                                    <div className="text-left">
                                        <b>Зміни</b>
                                    </div>
                                    <table className="table table-striped table-condensed">
                                        <tbody>
                                            <tr>
                                                <td>Менеджер</td>
                                                <td>Склад</td>
                                                <td className="no-mobile">Магазин</td>
                                                <td>Ціна</td>
                                                <td className="no-mobile">Дія</td>
                                                <td className="no-mobile">Час</td>
                                            </tr>
                                            {product?.logs[0] &&
                                                product.logs.map((log) => {
                                                    return (
                                                        <tr>
                                                            <td>
                                                                {log.user.name}
                                                                <div className="on-mobile">{product?.store?.title}</div>
                                                                <div className="on-mobile">2023-06-15 12:31:26</div>
                                                            </td>
                                                            <td>{product.shipper_id}</td>
                                                            <td className="no-mobile">{product?.store?.title}</td>
                                                            <td>{product.price}</td>
                                                            <td className="no-mobile">
                                                                {jsonToStaringHandler(JSON.parse(log.changes))}
                                                            </td>
                                                            <td className="no-mobile">
                                                                {moment(log.updated_at).format("DD.MM.YYYY hh:MM")}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default ModalFind;
